import clsx from 'clsx';
import { memo } from 'react';

import { usePriceRange } from '../../utils/data';

import { useTranslateFn } from '@shared/Translate';
import type { MatchWithTickets } from '@shared-types/ticketing.types';

import * as styles from './styles.module.scss';

type CategoriesItemProps = {
  data: MatchWithTickets[];
  catCode: string;
  setOverCategory: (category: string) => void;
};

const CategoryItem = ({ data, catCode, setOverCategory }: CategoriesItemProps) => {
  const t = useTranslateFn();

  const priceRange = usePriceRange(data, catCode);

  //we are waiting for category_5 onto EIDOS, now we are using FANS_FIRST
  const category = catCode === 'FANS_FIRST' ? 'category_5' : catCode.toLowerCase();
  return (
    <div
      className={clsx({ [styles.categoryItem]: true, [styles[category]]: true })}
      onFocus={() => {
        setOverCategory(category);
      }}
      onMouseOver={() => {
        setOverCategory(category);
      }}
      onMouseLeave={() => {
        setOverCategory(null);
      }}
    >
      <span className={styles.categoryItemName}>{t(`ticketing_${catCode.toLowerCase()}`)}</span>
      <span className='pk-font--base-bold'>{priceRange}</span>
    </div>
  );
};

export default memo(CategoryItem);
